
function definirIconeSolicitacao(solicitacoes_tipo_id, situacao_do_ultimo_andamento) {

  const IconeSolicitacao = {
    "1": { //CRIMES
      "Abrir": "./assets/img/Icones/solicitacoes/ABRIR_CRIMES.png",
      "Atender": "./assets/img/Icones/solicitacoes/ATENDER_CRIMES.png",
      "Aceitar": "./assets/img/Icones/solicitacoes/ACEITAR_CRIMES.png",
      "No local": "./assets/img/Icones/solicitacoes/NO_LOCAL_CRIMES.png",
      "Não Atender": "./assets/img/Icones/solicitacoes/NAOATENDER_CRIMES.png",
      "Despachar": "./assets/img/Icones/solicitacoes/DESPACHAR_CRIMES.png",
      "Reiterar": "./assets/img/Icones/solicitacoes/REITERAR_CRIMES.png",
      "Cancelar": "./assets/img/Icones/solicitacoes/CANCELAR_CRIMES.png",
      "Fechar": "./assets/img/Icones/solicitacoes/FECHARATENDER_CRIMES.png",
      "Fechar Não Atender": "./assets/img/Icones/solicitacoes/FECHARNAOATENDER_CRIMES.png",
      "Devolver": "./assets/img/Icones/solicitacoes/DEVOLVER_CRIMES.png",
      "Reclassificar": "./assets/img/Icones/solicitacoes/RECLASSIFICAR_CRIMES.png"
    },
    "2": { //PRAIA
      "Abrir": "./assets/img/Icones/solicitacoes/ABRIR_PRAIA.png",
      "Atender": "./assets/img/Icones/solicitacoes/ATENDER_PRAIA.png",
      "Aceitar": "./assets/img/Icones/solicitacoes/ACEITAR_PRAIA.png",
      "No local": "./assets/img/Icones/solicitacoes/NO_LOCAL_PRAIA.png",
      "Não Atender": "./assets/img/Icones/solicitacoes/NAOATENDER_PRAIA.png",
      "Despachar": "./assets/img/Icones/solicitacoes/DESPACHAR_PRAIA.png",
      "Reiterar": "./assets/img/Icones/solicitacoes/REITERAR_PRAIA.png",
      "Cancelar": "./assets/img/Icones/solicitacoes/CANCELAR_PRAIA.png",
      "Fechar": "./assets/img/Icones/solicitacoes/FECHARATENDER_PRAIA.png",
      "Fechar Não Atender": "./assets/img/Icones/solicitacoes/FECHARNAOATENDER_PRAIA.png",
      "Devolver": "./assets/img/Icones/solicitacoes/DEVOLVER_PRAIA.png",
      "Reclassificar": "./assets/img/Icones/solicitacoes/RECLASSIFICAR_PRAIA.png"
    },
    "3": { //POSTURAS MUNICIPAIS
      "Abrir": "./assets/img/Icones/solicitacoes/ABRIR_POSTURASMUNICIPAIS.png",
      "Atender": "./assets/img/Icones/solicitacoes/ATENDER_POSTURASMUNICIPAIS.png",
      "Aceitar": "./assets/img/Icones/solicitacoes/ACEITAR_POSTURASMUNICIPAIS.png",
      "No local": "./assets/img/Icones/solicitacoes/NO_LOCAL_POSTURASMUNICIPAIS.png",
      "Não Atender": "./assets/img/Icones/solicitacoes/NAOATENDER_POSTURASMUNICIPAIS.png",
      "Despachar": "./assets/img/Icones/solicitacoes/DESPACHAR_POSTURASMUNICIPAIS.png",
      "Reiterar": "./assets/img/Icones/solicitacoes/REITERAR_POSTURASMUNICIPAIS.png",
      "Cancelar": "./assets/img/Icones/solicitacoes/CANCELAR_POSTURASMUNICIPAIS.png",
      "Fechar": "./assets/img/Icones/solicitacoes/FECHARATENDER_POSTURASMUNICIPAIS.png",
      "Fechar Não Atender": "./assets/img/Icones/solicitacoes/FECHARNAOATENDER_POSTURASMUNICIPAIS.png",
      "Devolver": "./assets/img/Icones/solicitacoes/DEVOLVER_POSTURASMUNICIPAIS.png",
      "Reclassificar": "./assets/img/Icones/solicitacoes/RECLASSIFICAR_POSTURASMUNICIPAIS.png"
    },
    "4": { // TRANSITO
      "Abrir": "./assets/img/Icones/solicitacoes/ABRIR_TRANSITO.png",
      "Atender": "./assets/img/Icones/solicitacoes/ATENDER_TRANSITO.png",
      "Aceitar": "./assets/img/Icones/solicitacoes/ACEITAR_TRANSITO.png",
      "No local": "./assets/img/Icones/solicitacoes/NO_LOCAL_TRANSITO.png",
      'Não Atender': "./assets/img/Icones/solicitacoes/NAOATENDER_TRANSITO.png",
      "Despachar": "./assets/img/Icones/solicitacoes/DESPACHAR_TRANSITO.png",
      "Reiterar": "./assets/img/Icones/solicitacoes/REITERAR_TRANSITO.png",
      "Cancelar": "./assets/img/Icones/solicitacoes/CANCELAR_TRANSITO.png",
      "Fechar": "./assets/img/Icones/solicitacoes/FECHARATENDER_TRANSITO.png",
      "Fechar Não Atender": "./assets/img/Icones/solicitacoes/FECHARNAOATENDER_TRANSITO.png",
      "Devolver": "./assets/img/Icones/solicitacoes/DEVOLVER_TRANSITO.png",
      "Reclassificar": "./assets/img/Icones/solicitacoes/RECLASSIFICAR_TRANSITO.png",
    },
    "5": {//AUXILIOS
      "Abrir": "./assets/img/Icones/solicitacoes/ABRIR_AUXILIOS.png",
      "Atender": "./assets/img/Icones/solicitacoes/ATENDER_AUXILIOS.png",
      "Aceitar": "./assets/img/Icones/solicitacoes/ACEITAR_AUXILIOS.png",
      "No local": "./assets/img/Icones/solicitacoes/NO_LOCAL_AUXILIOS.png",
      "Não Atender": "./assets/img/Icones/solicitacoes/NAOATENDER_AUXILIOS.png",
      "Despachar": "./assets/img/Icones/solicitacoes/DESPACHAR_AUXILIOS.png",
      "Reiterar": "./assets/img/Icones/solicitacoes/REITERAR_AUXILIOS.png",
      "Cancelar": "./assets/img/Icones/solicitacoes/CANCELAR_AUXILIOS.png",
      "Fechar": "./assets/img/Icones/solicitacoes/FECHARATENDER_AUXILIOS.png",
      "Fechar Não Atender": "./assets/img/Icones/solicitacoes/FECHARNAOATENDER_AUXILIOS.png",
      "Devolver": "./assets/img/Icones/solicitacoes/DEVOLVER_AUXILIOS.png",
      "Reclassificar": "./assets/img/Icones/solicitacoes/RECLASSIFICAR_AUXILIOS.png",
    },
    "6": { // APREENSOES
      "Abrir": "./assets/img/Icones/solicitacoes/ABRIR_APREENSOES.png",
      "Atender": "./assets/img/Icones/solicitacoes/ATENDER_APREENSOES.png",
      "Aceitar": "./assets/img/Icones/solicitacoes/ACEITAR_APREENSOES.png",
      "No local": "./assets/img/Icones/solicitacoes/NO_LOCAL_APRENSOES.png",
      "Não Atender": "./assets/img/Icones/solicitacoes/NAOATENDER_APREENSOES.png",
      "Despachar": "./assets/img/Icones/solicitacoes/DESPACHAR_APREENSOES.png",
      "Reiterar": "./assets/img/Icones/solicitacoes/REITERAR_APREENSOES.png",
      "Cancelar": "./assets/img/Icones/solicitacoes/CANCELAR_APREENSOES.png",
      "Fechar": "./assets/img/Icones/solicitacoes/FECHARATENDER_APREENSOES.png",
      "Fechar Não Atender": "./assets/img/Icones/solicitacoes/FECHARNAOATENDER_APREENSOES.png",
      "Devolver": "./assets/img/Icones/solicitacoes/DEVOLVER_APREENSOES.png",
      "Reclassificar": "./assets/img/Icones/solicitacoes/RECLASSIFICAR_APREENSOES.png",
    },
    "7": { //Acidentes
      "Abrir": "./assets/img/Icones/solicitacoes/ABRIR_ACIDENTES.png",
      "Atender": "./assets/img/Icones/solicitacoes/ATENDER_ACIDENTES.png",
      "Aceitar": "./assets/img/Icones/solicitacoes/ACEITAR_ACIDENTES.png",
      "No local": "./assets/img/Icones/solicitacoes/NO_LOCAL_ACIDENTES.png",
      "Não Atender": "./assets/img/Icones/solicitacoes/NAOATENDER_ACIDENTES.png",
      "Despachar": "./assets/img/Icones/solicitacoes/DESPACHAR_ACIDENTES.png",
      "Reiterar": "./assets/img/Icones/solicitacoes/REITERAR_ACIDENTES.png",
      "Cancelar": "./assets/img/Icones/solicitacoes/CANCELAR_ACIDENTES.png",
      "Fechar": "./assets/img/Icones/solicitacoes/FECHARATENDER_ACIDENTES.png",
      "Fechar Não Atender": "./assets/img/Icones/solicitacoes/FECHARNAOATENDER_ACIDENTES.png",
      "Devolver": "./assets/img/Icones/solicitacoes/DEVOLVER_ACIDENTES.png",
      "Reclassificar": "./assets/img/Icones/solicitacoes/RECLASSIFICAR_ACIDENTES.png",
    },
    "8": { //MEIO AMBIENTE
      "Abrir": "./assets/img/Icones/solicitacoes/ABRIR_MEIOAMBIENTE.png",
      "Atender": "./assets/img/Icones/solicitacoes/ATENDER_MEIOAMBIENTE.png",
      "Aceitar": "./assets/img/Icones/solicitacoes/ACEITAR_MEIOAMBIENTE.png",
      "No local": "./assets/img/Icones/solicitacoes/NO_LOCAL_MEIOAMBIENTE.png",
      "Não Atender": "./assets/img/Icones/solicitacoes/NAOATENDER_MEIOAMBIENTE.png",
      "Despachar": "./assets/img/Icones/solicitacoes/DESPACHAR_MEIOAMBIENTE.png",
      "Reiterar": "./assets/img/Icones/solicitacoes/REITERAR_MEIOAMBIENTE.png",
      "Cancelar": "./assets/img/Icones/solicitacoes/CANCELAR_MEIOAMBIENTE.png",
      "Fechar": "./assets/img/Icones/solicitacoes/FECHARATENDER_MEIOAMBIENTE.png",
      "Fechar Não Atender": "./assets/img/Icones/solicitacoes/FECHARNAOATENDER_MEIOAMBIENTE.png",
      "Devolver": "./assets/img/Icones/solicitacoes/DEVOLVER_MEIOAMBIENTE.png",
      "Reclassificar": "./assets/img/Icones/solicitacoes/RECLASSIFICAR_MEIOAMBIENTE.png",
    },

    "9": { //ESCOLAS
      "Abrir": "./assets/img/Icones/solicitacoes/ABRIR_ESCOLAS.png",
      "Atender": "./assets/img/Icones/solicitacoes/ATENDER_ESCOLAS.png",
      "Aceitar": "./assets/img/Icones/solicitacoes/ACEITAR_ESCOLAS.png",
      "No local": "./assets/img/Icones/solicitacoes/NO_LOCAL_ESCOLAS.png",
      "Não Atender": "./assets/img/Icones/solicitacoes/NAOATENDER_ESCOLAS.png",
      "Despachar": "./assets/img/Icones/solicitacoes/DESPACHAR_ESCOLAS.png",
      "Reiterar": "./assets/img/Icones/solicitacoes/REITERAR_ESCOLAS.png",
      "Cancelar": "./assets/img/Icones/solicitacoes/CANCELAR_ESCOLAS.png",
      "Fechar": "./assets/img/Icones/solicitacoes/FECHARATENDER_ESCOLAS.png",
      "Fechar Não Atender": "./assets/img/Icones/solicitacoes/FECHARNAOATENDER_ESCOLAS.png",
      "Devolver": "./assets/img/Icones/solicitacoes/DEVOLVER_ESCOLAS.png",
      "Reclassificar": "./assets/img/Icones/solicitacoes/RECLASSIFICAR_ESCOLAS.png",
    },
    "10": { // REBOQUE
      "Abrir": "./assets/img/Icones/solicitacoes/ABRIR_REBOQUE.png",
      "Atender": "./assets/img/Icones/solicitacoes/ATENDER_REBOQUE.png",
      "Aceitar": "./assets/img/Icones/solicitacoes/ACEITAR_REBOQUE.png",
      "No local": "./assets/img/Icones/solicitacoes/NO_LOCAL_REBOQUE.png",
      "Não Atender": "./assets/img/Icones/solicitacoes/NAOATENDER_REBOQUE.png",
      "Despachar": "./assets/img/Icones/solicitacoes/DESPACHAR_REBOQUE.png",
      "Reiterar": "./assets/img/Icones/solicitacoes/REITERAR_REBOQUE.png",
      "Cancelar": "./assets/img/Icones/solicitacoes/CANCELAR_REBOQUE.png",
      "Fechar": "./assets/img/Icones/solicitacoes/FECHARATENDER_REBOQUE.png",
      "Fechar Não Atender": "./assets/img/Icones/solicitacoes/FECHARNAOATENDER_REBOQUE.png",
      "Devolver": "./assets/img/Icones/solicitacoes/DEVOLVER_REBOQUE.png",
      "Reclassificar": "./assets/img/Icones/solicitacoes/RECLASSIFICAR_REBOQUE.png",
    },
    "11": { // POSTURAS MUNICIPAIS
      "Abrir": "./assets/img/Icones/solicitacoes/ABRIR_POSTURASMUNICIPAIS.png",
      "Atender": "./assets/img/Icones/solicitacoes/ATENDER_POSTURASMUNICIPAIS.png",
      "Aceitar": "./assets/img/Icones/solicitacoes/ACEITAR_POSTURASMUNICIPAIS.png",
      "No local": "./assets/img/Icones/solicitacoes/NO_LOCAL_POSTURASMUNICIPAIS.png",
      "Não Atender": "./assets/img/Icones/solicitacoes/NAOATENDER_POSTURASMUNICIPAIS.png",
      "Despachar": "./assets/img/Icones/solicitacoes/DESPACHAR_POSTURASMUNICIPAIS.png",
      "Reiterar": "./assets/img/Icones/solicitacoes/REITERAR_POSTURASMUNICIPAIS.png",
      "Cancelar": "./assets/img/Icones/solicitacoes/CANCELAR_POSTURASMUNICIPAIS.png",
      "Fechar": "./assets/img/Icones/solicitacoes/FECHARATENDER_POSTURASMUNICIPAIS.png",
      "Fechar Não Atender": "./assets/img/Icones/solicitacoes/FECHARNAOATENDER_POSTURASMUNICIPAIS.png",
      "Devolver": "./assets/img/Icones/solicitacoes/DEVOLVER_POSTURASMUNICIPAIS.png",
      "Reclassificar": "./assets/img/Icones/solicitacoes/RECLASSIFICAR_POSTURASMUNICIPAIS.png",
    }
  }

  return IconeSolicitacao[solicitacoes_tipo_id][situacao_do_ultimo_andamento];
}

function definirIconeAgente(situacao_do_ultimo_andamento) {

  const IconeAgente = {
    "No local": "assets/img/portrait/small/icon-man-small - red.png",
    "Despachar": "assets/img/portrait/small/icon-man-small -green.png",
    "Aceitar": "assets/img/portrait/small/icon-man-small -green.png",
    default: "assets/img/portrait/small/icon-man-small_selected.png"
  }
  return IconeAgente[situacao_do_ultimo_andamento] || IconeAgente.default
}

export { definirIconeSolicitacao, definirIconeAgente };



// WEBPACK FOOTER //
// ./src/app/shared/utils/definir_icone.ts